import type { SharedValue } from 'react-native-reanimated';

/**
 * Shared tooltip helpers for the line chart and the savings goal chart so both
 * render the same tooltip markers on web (HTML) and native (Skia).
 */

/** Width of the series marker bar shown next to each tooltip row label */
export const TOOLTIP_MARKER_WIDTH = 3;

/** Horizontal gap between the label and value columns of a tooltip row */
export const TOOLTIP_COL_GAP = 12;

/** A marker position/size that may be animated with a Reanimated shared value */
export type TooltipMarkerValue = number | SharedValue<number>;

export type TooltipMarkerProps = {
  /** Left edge of the marker bar */
  x: TooltipMarkerValue;
  /** Top edge of the marker bar */
  y: TooltipMarkerValue;
  /** Row height; the bar spans the full row */
  height: TooltipMarkerValue;
  color: string;
  opacity?: TooltipMarkerValue;
};

// Web series marker matching the app tooltip: a short vertical rounded bar
export const markerBar = (markerColor: string) =>
  `<span style="display: inline-block; width: ${TOOLTIP_MARKER_WIDTH}px; height: 1em; border-radius: 2px; background: ${markerColor};"></span>`;
